import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { CycleModule } from "@/store/modules/cycle.module";
import { CycleSearchModel } from "@/store/models/cycle/cycleSearchData";
import { PACycleRequestModel } from "@/store/models/cycle/paCycleRequestDTO";
import cycleListingMachine from "./machines/cyclesListing.Machines";
import { interpret } from "xstate";
import { Guid } from "guid-typescript";
import _ from "lodash";
import DeleteComponent from "@/components/deleteComponent.vue";
import CycleReviewsSummary from "../reviews/components/CycleReviewsSummary.vue";
// import img from "@/assets/images/users/avatar-1.jpg"
let CycleListing = /** @class */ (() => {
    let CycleListing = class CycleListing extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Cycles";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                    href: "#",
                },
                {
                    text: "Cycles",
                    active: true,
                },
            ];
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.totalCount = 0;
            this.selectedCycleStatus = "All";
            this.cycleName = "";
            this.teamName = "All";
            this.employeeName = "";
            this.status = "All";
            this.year = "";
            this.emptyGuids = Guid.createEmpty();
            this.cycleId = "";
            this.searchData = new CycleSearchModel();
            this.cycledta = new PACycleRequestModel();
            this.cycleStatus = ["All", "Progressing", "Delivered"];
            this.cycleFilter = false;
            this.cycleLegend = false;
            this.isPopoverVisible = false;
            this.popoverTarget = "";
            this.columnsWithActions = [
                {
                    field: "name",
                    label: "Cycle Name",
                    thClass: "cycle-name-header",
                    sortable: true,
                },
                {
                    field: "period",
                    label: "Period",
                    thClass: "cycle-period-header",
                    sortable: false,
                },
                {
                    field: "Reviewees",
                    label: "Reviewees",
                    thClass: "cycle-reviewees-header",
                    sortable: false,
                },
                {
                    field: "cycleStatus",
                    label: "Status",
                    thClass: "cycle-status-header",
                    sortable: false,
                },
                {
                    field: "reviewMeetingStatus",
                    label: "Review Meeting Status",
                    thClass: "cycle-status-header",
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "cycle-action",
                    sortable: false,
                },
            ];
            this.columnsWithOutActions = [
                {
                    field: "name",
                    label: "Cycle Name",
                    thClass: "cycle-name-header",
                    sortable: true,
                },
                {
                    field: "period",
                    label: "Period",
                    thClass: "cycle-period-header",
                    sortable: false,
                },
                {
                    field: "Reviewees",
                    label: "Reviewees",
                    thClass: "cycle-reviewees-header",
                    sortable: false,
                },
                {
                    field: "cycleStatus",
                    label: "Status",
                    thClass: "cycle-status-header",
                    sortable: false,
                },
                {
                    field: "reviewMeetingStatus",
                    label: "Review Meeting Status",
                    thClass: "cycle-status-header",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                page: 1,
                pageSize: 10,
                sort: {
                    field: "name",
                    type: "none",
                },
            };
            this.machine = cycleListingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.initialSortBy = {
                field: "name",
                type: "none",
            };
            this.isPageDirty = false;
            this.isGridClearApplied = false;
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            var dataz = CycleModule.gridParams;
            if (dataz && Object.keys(dataz).length != 0) {
                this.searchData = {
                    page: this.serverParams.page,
                    pageSize: this.serverParams.pageSize,
                    sort: this.serverParams.sort,
                    columnFilters: filters,
                    cycleFilters: dataz.cycleFilters,
                };
            }
            else {
                this.searchData = {
                    page: this.serverParams.page,
                    pageSize: this.serverParams.pageSize,
                    sort: this.serverParams.sort,
                    columnFilters: filters,
                    cycleFilters: this.cycledta,
                };
            }
            CycleModule.AssignParams(_.cloneDeep(this.searchData));
            this.machineService.send({ type: "GETTING_CYCLES", searchData: this.searchData });
        }
        get emptyGuidss() {
            return this.emptyGuids.value;
        }
        get legends() {
            return CycleModule.legends;
        }
        ApplyFilter() {
            this.AppliedFilters();
            this.serverParams.page = 1;
            CycleModule.AssignCycleDataParams(_.cloneDeep(this.cycledta));
            this.loadItems();
            return (this.cycleFilter = false);
        }
        closeFilterCard() {
            this.cycleFilter = false;
        }
        AppliedFilters() {
            ////this.serverParams.page = this.initialPage;
            this.cycleName = this.cycledta.cycleName;
            this.teamName = this.cycledta.teamName;
            this.employeeName = this.cycledta.employeeName;
            this.year = this.cycledta.year;
            this.status = this.cycledta.status;
            if (this.cycledta.pmoTeamId != this.emptyGuids) {
                var team = this.teams.find((x) => x.id == this.cycledta.pmoTeamId);
                if (team != null) {
                    this.teamName = team.value;
                }
                else {
                    this.teamName = "All";
                }
            }
        }
        ResetPagination() {
            this.serverParams.initialPage = 1;
        }
        selectCycleStatus(statusCycle) {
            this.cycledta.status = statusCycle;
        }
        clearFilter() {
            this.cycleFilter = false;
            CycleModule.AssignParams(null);
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].cycleFilters = new PACycleRequestModel();
            if (this.cycledta.cycleName || this.cycledta.employeeName || this.cycledta.status != "All" || this.cycledta.teamName != "All" || this.cycledta.pmoTeamId !== null || this.cycledta.year) {
                this.serverParams.columnFilters = {};
                this.isGridClearApplied = true;
                this.clearDefaults();
                this.cycledta = new PACycleRequestModel();
            }
            this.loadItems();
        }
        clearDefaults() {
            (this.cycleName = ""), (this.employeeName = ""), (this.year = ""), (this.teamName = "All"), (this.status = "All");
        }
        getDefaultCycleData() {
            return {
                cycleName: "",
                employeeName: "",
                year: "",
                pmoTeamId: null,
                teamName: "All",
                status: "All",
            };
        }
        resetCycleData() {
            const defaultData = this.getDefaultCycleData();
            Object.assign(this.cycledta, defaultData);
            this.cycleName = "";
            this.teamName = "All";
            this.employeeName = null;
            this.year = "";
            this.status = "All";
            this.totalCount = 0;
        }
        getDefaultSearchData() {
            return {
                page: this.initialPage,
                pageSize: this.initialPageSize,
                sort: this.serverParams.sort,
                columnFilters: [],
                cycleFilters: this.getDefaultCycleData(),
            };
        }
        onRowClick(params) {
            this.$router.push({ name: "CycleOverview", params: { cycleId: params.row.id } });
        }
        showCreateCycle() {
            this.$router.push({ name: "CreateCycle" });
        }
        get anyFilterApplied() {
            return this.cycleName || this.teamName || this.employeeName || this.year || this.status;
        }
        get rows() {
            return CycleModule.cycles;
        }
        get yearList() {
            return CycleModule.yearList;
        }
        get teams() {
            return CycleModule.teams;
        }
        get totalCycleCount() {
            return CycleModule.totalCount;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get cycleSummary() {
            return CycleModule.paCycleReviewsStatus;
        }
        initialize() {
            var value = CycleModule.gridParams;
            if (value) {
                this.isPageDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                this.serverParams.cycleFilters = value.cycleFilters;
                this.initialSortBy = value.sort;
                this.cycledta = value.cycleFilters;
                if (value.cycleFilters != null && value.cycleFilters != undefined) {
                    this.cycleName = value.cycleFilters.cycleName;
                    this.employeeName = value.cycleFilters.employeeName;
                    this.status = value.cycleFilters.status;
                    this.year = value.cycleFilters.year;
                    this.teamName = value.cycleFilters.teamName;
                }
            }
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "CreateCycle" && from.name != "CycleOverview") {
                CycleModule.ResetPage();
            }
            next();
        }
        showFilter() {
            this.cycleFilter = !this.cycleFilter;
        }
        showLegend() {
            this.cycleLegend = !this.cycleLegend;
        }
        closeLegend() {
            this.cycleLegend = false;
        }
        findLegend(stepName) {
            var value = this.legends.find((legend) => legend.stepName === stepName);
            if (value) {
                return value.stepStyle;
            }
            return null;
        }
        RemoveCycle(cycleId) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.machineService.send({ type: "DELETE_CYCLES", ispageChanged: isPageChanged });
            this.cycleId = cycleId;
        }
        showReviewStatus(id) {
            if ((this.isPopoverVisible = true)) {
                this.closeCycleSummaryCard();
            }
            this.machineService.send({ type: "FETCH_REVIEWS_STATUS", cycleId: id });
            this.popoverTarget = `${id}`;
            this.isPopoverVisible = true;
        }
        closeCycleSummaryCard() {
            this.isPopoverVisible = false;
            this.machineService.send({ type: "CLOSE_REVIEWS_STATUS" });
        }
        DeleteCycle() {
            this.machineService.send({ type: "DELETING_CYCLES", cycleId: this.cycleId });
        }
        cancel() {
            this.machineService.send({ type: "CANCEL_DELETE" });
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                this.totalCount = this.totalCycleCount;
                if (this.state.matches("loadedCycles")) {
                    this.isGridLoading = false;
                    this.isPageDirty = false;
                }
                if (this.state.matches("gettingCycles") && previousState.matches("deletingCycle")) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    CycleListing = __decorate([
        Component({
            name: "CycleListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
                DeleteComponent,
                CycleReviewsSummary,
            },
        })
    ], CycleListing);
    return CycleListing;
})();
export default CycleListing;
